export default __webpack_public_path__ + "svg/calendar/2026/1/febrero.svg?43ad1eb8";